import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-email",
  "use": "icon-email-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-email\"><path d=\"M1024 512c0-282.763636-229.236364-512-512-512C229.236364 0 0 229.236364 0 512c0 282.763636 229.236364 512 512 512C794.763636 1024 1024 794.763636 1024 512zM835.630545 707.956364l-176.221091-148.48 42.868364-24.203636 156.206545 125.533091L835.630545 707.956364zM162.909091 325.818182l349.090909 209.454545L861.090909 325.818182l0 46.545455L512 581.818182 162.909091 372.363636 162.909091 325.818182zM170.263273 698.507636l-22.807273-47.150545 156.16-125.533091 42.868364 24.203636L170.263273 698.507636z\" p-id=\"26328\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/email.svg
// module id = +4G4
// module chunks = 12